// copied from https://stackoverflow.com/a/4565120/4591241
const checkIsChrome = (): boolean => {
  return (
    /Chrome/.test(navigator.userAgent) &&
    /Google Inc/.test(navigator.vendor) &&
    !('brave' in navigator)
  )
}

export default checkIsChrome
